import React from "react";
import * as moment from "moment";

 
export const matchItem = (parts) => {
  return (
    <div>
      {parts.map((part, index) => (
        <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
          {part.text}
        </span>
      ))}
    </div>
  );
};
export const isObjEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};
export const validaIdentificacionPersona = new RegExp(
  /^[a-zA-Z 1234567890 ñÑ]*$/
);
export const regExpNumeros = new RegExp(/^\d+$/gi);
export const validaCorreo = new RegExp(/^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/);

// Funciones para validar informacion
export function validaSoloNumeros(dataValidar) {
  if (isNaN(dataValidar)) {
    return false;
  }
}
export function decimalFormat(num) {
  if (!num) return 0;
  return `${parseFloat(num).toFixed(2)}`;
}
export function fechaHoraFormat(date) {
  const NewDate = moment(date).format("DD/MM/YYYY hh:mm a");
  return NewDate;
}

export function localdatetime(date) {
  if (!date) return "";
  //console.log(date);
  //console.log(moment(date).format("YYYY-MM-DD"));
  return moment(date).format("YYYY-MM-DD");
}
export function fechaFormat(date) {
  const NewDate = moment(date).format("YYYY-MM-DD");
  return NewDate;
}

export const dateFormat = (date) => {
  const dateLong = date.includes("T") ? date : date.concat("T00:00:00-5");
  const dateCompleteArray = dateLong.split("T");
  const dateArray = dateCompleteArray[0].split("-");
  const month = dateArray[1];
  const monthArray = {
    1: "ENE",
    2: "FEB",
    3: "MAR",
    4: "ABR",
    5: "MAY",
    6: "JUN",
    7: "JUL",
    8: "AGO",
    9: "SEP",
    10: "OCT",
    11: "NOV",
    12: "DIC",
  };
  const day = dateArray[2];
  const hourArray = dateCompleteArray[1].split("-");
  const hour = hourArray[0];
  return {
    day,
    month: monthArray[parseInt(month)],
    hour,
    date: dateCompleteArray[0],
  };
};

export const validaCedula = (cedula) => {
  if (!/^\d{10}$/.test(cedula)) {
    return false;
  }
  let dijitoValidar = cedula.substring(9, 10);

  const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
  let suma = 0;

  for (let i = 0; i < coeficientes.length; i++) {
    let valor = parseInt(cedula.charAt(i)) * coeficientes[i];
    if (valor > 9) {
      valor = valor - 9;
    }
    suma += valor;
  }

  const residuo = suma % 10;

  const digitoVerificador = residuo === 0 ? 0 : 10 - residuo;
  return digitoVerificador === Number(dijitoValidar);
};

export const downloadBase64PDF = (pdfData, fileName) => {
  const element = document.createElement("a");
  element.style = "display: none;";
  element.href = `data:application/pdf;base64,${pdfData}`;
  element.download = fileName;
  document.body.appendChild(element)
  element.click();
  element.remove();
}
